import { useCallback, useEffect, useRef, useState } from 'react';
import { FileWithPath, useDropzone } from 'react-dropzone';
import uploadImage from '../../assets/icons/upload-files-illustration.svg';
import pdfFile from '../../assets/icons/pdf-file-illustratiion.svg';
import binIcon from '../../assets/icons/bin-icon.svg';
import ZahtjeviService from '../../service/ZahtjeviService';
import { useAppDispatch } from '../../store/hooks/hooks';
import { setDohvaceniZahtjevi } from '../../store/slice/ZahtjeviSlice';
import { zahtjevToZahtjevTable } from '../../common/utils/HelperFunction';
import { Zahtjev } from '../../common/types/types';

interface Props {
  setModalOn: (modalOn: boolean) => void;
  setShowUploadFalse: (isUploaded: boolean) => void;
}

export const UploadPDF = ({ setShowUploadFalse, setModalOn }: Props) => {
  const [files, setFiles] = useState<FileWithPath[]>([]);
  const [rejectedFilesCustomList, setRejectedFilesCustomList] = useState<Array<string>>([]);

  const modalRef = useRef<HTMLDivElement>(null);

  const dispatch = useAppDispatch();

  useEffect(() => {
    const handleMouseDown = (event: MouseEvent) => {
      if (!modalRef.current?.contains(event.target as Node)) {
        setModalOn(false);
      }
    };
    window.addEventListener('mousedown', handleMouseDown);

    const handleEsc = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setModalOn(false);
      }
    };
    window.addEventListener('keydown', handleEsc);

    return () => {
      window.removeEventListener('keydown', handleEsc);
      window.removeEventListener('mousedown', handleMouseDown);
    };
  }, []);

  const onDrop = useCallback((acceptedFiles: FileWithPath[]) => {
    setRejectedFilesCustomList([]);
    // console.log(acceptedFiles);

    ///---------------Dodavanje rejected fileova u listu------------------------------------------------------

    acceptedFiles.forEach((file) => {
      if (file.name.length > 100) {
        setRejectedFilesCustomList((prevItems) => [...prevItems, `${file.name}  ---rejected due to too many characters---`]);
      }
    });

    //----------------Primi samo one fileove koji imaju krace ili jednako ime od 100 znakova-------------------
    const validFiles = acceptedFiles.filter((file) => file.name.length <= 100);

    let reader = new FileReader();

    //------citanje i ispis contenta pdf-a------

    reader.onload = function (e) {
      let contents = e.target?.result;
      // console.log(contents);
    };
    reader.readAsText(validFiles[0]);
    //-------------------------------------------

    if (validFiles?.length > 0) {
      setFiles((previousFiles: FileWithPath[]) => [
        ...previousFiles,
        ...validFiles.map((file) => Object.assign(file, { preview: URL.createObjectURL(file) })),
      ]);
    }
  }, []);
  const { getRootProps, getInputProps, isDragActive, acceptedFiles, isFocused, isDragAccept, isDragReject, fileRejections } = useDropzone({
    onDrop,
    maxSize: 29360128,
    maxFiles: 20,
    accept: {
      'application/pdf': ['.pdf'],
    },
  });

  const acceptedFileItems = files.map((file, index) => (
    <div key={index} className='uploaded-file'>
      <picture className='uploaded-file__picture '>
        <img className='uploaded-file__picture__img' src={pdfFile} alt='' />
      </picture>
      <span className='uploaded-file__name break-word' key={index}>
        {file.path}
      </span>
      <span className='uploaded-file__size gray-100'>{(file.size / (1024 * 1024)).toFixed(2)}mb</span>
      <picture className='uploaded-file__bin-picture margin-right-1'>
        <img onClick={() => removeFile(index)} className='uploaded-file__bin-picture__img' src={binIcon} alt='' />
      </picture>
    </div>
  ));

  const fileRejectionItems = fileRejections.map(({ file, errors }, index) => {
    return (
      <li key={index}>
        {file.name} ---{errors[0].code}
      </li>
    );
  });

  // const removeFile = (name: string) => {
  //   setFiles((files) => files.filter((file) => file.name !== name));
  // };
  const removeFile = (elementIndex: number) => {
    setFiles((files) => files.filter((file, index) => index !== elementIndex));
  };

  const uploadFiles = (event: any) => {
    event?.preventDefault();
    let requestForm: FormData = new FormData();
    files.forEach((file) => {
      requestForm.append('file', file);
    });
    ZahtjeviService.addZahtjev(requestForm).then(() => {
      ZahtjeviService.getZahtjevi()
        .then((response) => {
          let sviZahtjevi: Array<Zahtjev> = response.data;
          ZahtjeviService.getArchivedZahtjevi().then((responseArchived) => {
            sviZahtjevi = [...sviZahtjevi, ...responseArchived.data];
            dispatch(setDohvaceniZahtjevi(zahtjevToZahtjevTable(sviZahtjevi)));
          });
        })
        .finally(() => {
          setShowUploadFalse(true);
        });
    });
  };

  return (
    <div className='modal-active dark-100'>
      <div className='main-modal'>
        <div className='padding-bottom-5' ref={modalRef}>
          <form className='form modal-form dropzone font-h5-regular'>
            <h3 className='dropzone__title font-h3-regular'>Upload PDFs</h3>
            <div
              {...getRootProps({
                className: `dropzone__box ${isFocused && 'focus'} ${isDragAccept && 'accept'} ${isDragReject && 'reject'} `,
              })}
            >
              <picture className='dropzone__box__picture'>
                <img className='dropzone__box__picture__img' src={uploadImage} alt='' />
              </picture>
              <h3 className='font-h3-regular'>Drag & Drop</h3>
              <input {...getInputProps()} />
              {isDragActive ? (
                <></>
              ) : (
                <div className='text-center'>
                  <p className='font-h5-regular dark-400'>or click here to upload files</p>
                  <p className='font-h6-regular primary-200'>Upload up to 20 files. Max upload size ~ 28MB</p>
                  <p className='font-h6-regular primary-200'>Max characters in document name is 50.</p>
                </div>
              )}
            </div>

            {rejectedFilesCustomList.length > 0 && <span>Rejected files</span>}
            <ul>
              {fileRejectionItems}
              {rejectedFilesCustomList.map((file, index) => (
                <li key={index}>{file}</li>
              ))}
            </ul>

            {acceptedFileItems}

            {files.length ? <div className='text-right'>Count: {files.length}</div> : <></>}
            <div className='dropzone__buttons'>
              <span onClick={() => setShowUploadFalse(false)} className='button-tertionary margin-right-1'>
                Cancel
              </span>
              <button disabled={files.length === 0} className='button-primary' onClick={uploadFiles}>
                Upload
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
